export enum ErrorCode {
  UNKNOWN = 'UNKNOWN',
}

export class AppError extends Error {
  code: ErrorCode;
  message: string;
  params: Record<string, any>;
  constructor(
    message: string,
    code: ErrorCode = ErrorCode.UNKNOWN,
    params: Record<string, any> = {}
  ) {
    super(message);
    this.name = 'ApiError';
    this.code = code;
    this.message = message;
    this.params = params;
  }
}
